import { Box, Flex, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import CategoryForm from "./CategoryForm";
import { H2 } from "components/text/headings";

function FuelAndEnergyRelatedActivities({
  defaultValues,
  tabKey,
  handleCategoryChange,
  finalize,
  finalizeQuestionnaire,
}) {
  const { t } = useTranslation("translation", {
    keyPrefix: "organizationQuestionnaire.scope3",
  });
  const {
    id: questionnaireId,
    categories: { fuelAndEnergyRelatedActivities },
  } = defaultValues;
  const { handleSubmit } = useForm({
    fuelAndEnergyRelatedActivities,
  });

  const formId = `formStep${tabKey}`;

  const onSubmit = () => {
    finalize ? finalizeQuestionnaire(questionnaireId) : handleCategoryChange();
  };

  return (
    <CategoryForm onSubmit={handleSubmit(onSubmit)} id={formId}>
      <Text opacity="0.75" fontSize="sm" marginBlockEnd="4">
        {t(`categories.${tabKey}Desc`)}
      </Text>
      {/* PURCHASED FUEL 1*/}
      <Box marginBlockStart="12">
        <Flex alignItems="center" gap="5">
          <Box borderRadius="full" inlineSize="7" blockSize="7" textAlign="center" backgroundColor="esg_gray.100">
            <H2>A</H2>
          </Box>
          <Text fontSize="md" fontWeight="bold">
            Upstream emissions of purchased fuels
          </Text>
        </Flex>
        <Box marginBlockStart="14">
          <TableContainer marginBlockStart="10">
            <Table variant="simple" size="lg">
              <Thead>
                <Tr>
                  <Th textTransform="none">User Input</Th>
                  <Th textTransform="none">Emissions Factor</Th>
                  <Th textTransform="none">
                    Emissions (kg CO<sub>2e</sub>)
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {fuelAndEnergyRelatedActivities.userInputUpstreamEmissionOfPurchasedFuels?.map((item, index) => {
                  return (
                    <Tr key={index}>
                      <Td>{item.userInput}</Td>
                      <Td>{item.emissionsFactor}</Td>
                      <Td>{item.emissions}</Td>
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
      {/* PURCHASED FUEL 2*/}
      <Box marginBlockStart="12">
        <Flex alignItems="center" gap="5">
          <Box borderRadius="full" inlineSize="7" blockSize="7" textAlign="center" backgroundColor="esg_gray.100">
            <H2>B</H2>
          </Box>
          <Text fontSize="md" fontWeight="bold">
            Upstream emissions of purchased fuels
          </Text>
        </Flex>
        <Box marginBlockStart="14">
          <TableContainer marginBlockStart="14">
            <Table variant="simple" size="lg">
              <Thead>
                <Tr>
                  <Th textTransform="none">Country</Th>
                  <Th textTransform="none">Emissions Factor</Th>
                  <Th textTransform="none">
                    Emissions (kg CO<sub>2e</sub>)
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {fuelAndEnergyRelatedActivities.countryUpstreamEmissionOfPurchasedFuels?.map((item, index) => {
                  return (
                    <Tr key={index}>
                      <Td>{item.country}</Td>
                      <Td>{item.emissionsFactor}</Td>
                      <Td>{item.emissions}</Td>
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
      {/* TRANSMISSION AND DISTRIBUTION*/}
      <Box marginBlockStart="12">
        <Flex alignItems="center" gap="5">
          <Box borderRadius="full" inlineSize="7" blockSize="7" textAlign="center" backgroundColor="esg_gray.100">
            <H2>C</H2>
          </Box>
          <Text fontSize="md" fontWeight="bold">
            Emissions from transmission and distribution losses
          </Text>
        </Flex>
        <Box marginBlockStart="14">
          <TableContainer marginBlockStart="14">
            <Table variant="simple" size="lg">
              <Thead>
                <Tr>
                  <Th textTransform="none">Country</Th>
                  <Th textTransform="none">Emissions Factor</Th>
                  <Th textTransform="none">
                    Emissions (kg CO<sub>2e</sub>)
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {fuelAndEnergyRelatedActivities.emissionsFromTransmissionAndDistributionLoses?.map((item, index) => {
                  return (
                    <Tr key={index}>
                      <Td>{item.country}</Td>
                      <Td>{item.emissionsFactor}</Td>
                      <Td>{item.emissions}</Td>
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </CategoryForm>
  );
}

export default FuelAndEnergyRelatedActivities;
